const Promise = require('bluebird')
const globalPageContext = require('client/lib/business-events/page-context')
const { RequestError } = require('client/lib/request')

module.exports = function (url, name, file, options) {
  const { csrfToken, onProgress } = normalizeOptions(options)

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const captureStackErr = new Error('capture stack')

    xhr.onreadystatechange = event => {
      if (xhr.readyState === XMLHttpRequest.OPENED) {
        onProgress(event, 0)
      }
      if (xhr.readyState === XMLHttpRequest.DONE) {
        // Backwards-compatibility — not needed or desired otherwise
        if (onProgress.isDefaultUploaderOnProgressCallback) {
          onProgress(event, 0)
        }
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText)
        } else {
          const err = RequestError.fromXHR(url, xhr)
          err.stack = captureStackErr.stack
          reject(err)
        }
      }
    }

    xhr.upload.onprogress = event => {
      if (event.lengthComputable) {
        const percentLoaded = (event.loaded / event.total) * 100
        onProgress(event, percentLoaded)
      }
    }

    const pageContext = globalPageContext.getPageContext()

    const formData = new FormData()
    formData.append('_csrf', csrfToken)
    formData.append('_page_context', JSON.stringify(pageContext))
    formData.append(name, file)

    xhr.open('POST', url, true)
    xhr.send(formData)
  })
}

function normalizeOptions(options = {}) {
  return Object.assign({
    csrfToken: typeof wiggin === 'object' ? wiggin._csrf : null,
    onProgress: defaultOnProgressCallback()
  }, options)
}

function defaultOnProgressCallback() {
  const $progress = $('.upload-progress')
  const callback = function (event, percentage) {
    $progress.val(percentage)
  }
  callback.isDefaultUploaderOnProgressCallback = true
  return callback
}
